import * as types from '../../lib/actionTypes.es6';

export function getLookupListTypesRequest() {
  return { type: types.GET_LOOKUP_LIST_TYPES_REQUEST };
}

export function getLookupListTypesSuccess(data) {
  return { type: types.GET_LOOKUP_LIST_TYPES_SUCCESS, payload: data };
}

export function getLookupListTypesFailure(error) {
  return { type: types.GET_LOOKUP_LIST_TYPES_FAILURE, payload: error };
}

export function getLookupListRequest(listType) {
  return { type: types.GET_LOOKUP_LIST_REQUEST, payload: listType };
}

export function getLookupListSuccess(listType, data) {
  return { type: types.GET_LOOKUP_LIST_SUCCESS, payload: { listType: listType, data: data } };
}

export function getLookupListFailure(listType, error) {
  return { type: types.GET_LOOKUP_LIST_FAILURE, payload: { listType: listType, error: error } };
}

export function addLookupListItemRequest(listType, item) {
  return { type: types.ADD_LOOKUP_LIST_ITEM_REQUEST, payload: { listType: listType, item: item } };
}

export function addLookupListItemSuccess(listType, data) {
  return { type: types.ADD_LOOKUP_LIST_ITEM_SUCCESS, payload: { listType: listType, data: data } };
}

export function addLookupListItemFailure(listType, error) {
  return { type: types.ADD_LOOKUP_LIST_ITEM_FAILURE, payload: { listType: listType, error: error } };
}

export function updateLookupListItemRequest(listType, itemValue, patch) {
  return { type: types.UPDATE_LOOKUP_LIST_ITEM_REQUEST, payload: { listType: listType, itemValue: itemValue, patch: patch } };
}

export function updateLookupListItemSuccess(listType, data) {
  return { type: types.UPDATE_LOOKUP_LIST_ITEM_SUCCESS, payload: { listType: listType, data: data } };
}

export function updateLookupListItemFailure(listType, error) {
  return { type: types.UPDATE_LOOKUP_LIST_ITEM_FAILURE, payload: { listType: listType, error: error } };
}

export function deleteLookupListItemRequest(listType, itemValue) {
  return { type: types.DELETE_LOOKUP_LIST_ITEM_REQUEST, payload: { listType: listType, itemValue: itemValue } };
}

export function deleteLookupListItemSuccess(listType, data) {
  return { type: types.DELETE_LOOKUP_LIST_ITEM_SUCCESS, payload: { listType: listType, data: data } };
}

export function deleteLookupListItemFailure(listType, error) {
  return { type: types.DELETE_LOOKUP_LIST_ITEM_FAILURE, payload: { listType: listType, error: error } };
}
